import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// budgets — งบประมาณ (Budget)
// ============================================================================
export const budgets = sqliteTable("accounting_budgets", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  fiscalYearId: text("fiscal_year_id"),
  name: text("name").notNull(), // e.g., "งบประมาณปี 2026"
  periodFrom: text("period_from").notNull(), // YYYY-MM-DD
  periodTo: text("period_to").notNull(), // YYYY-MM-DD
  status: text("status", {
    enum: ["draft", "approved", "locked"],
  })
    .notNull()
    .default("draft"),
  remarks: text("remarks"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  budgetCompanyIdx: index("budget_company_idx").on(table.companyId, table.status),
}));

// Type exports
export type Budget = typeof budgets.$inferSelect;
export type NewBudget = typeof budgets.$inferInsert;

// ============================================================================
// budget_lines — รายการงบประมาณ (Budget Line)
// ============================================================================
export const budgetLines = sqliteTable("accounting_budget_lines", {
  id: text("id").primaryKey(), // ULID
  budgetId: text("budget_id").notNull(),
  accountId: text("account_id").notNull(), // expense account
  costCenterId: text("cost_center_id"), // nullable
  month: text("month").notNull(), // YYYY-MM format
  amount: real("amount").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at"),
  updatedBy: text("updated_by"),
}, (table) => ({
  blBudgetIdx: index("bl_budget_idx").on(table.budgetId),
  blAccountMonthIdx: index("bl_account_month_idx").on(table.budgetId, table.accountId, table.month),
}));

// Type exports
export type BudgetLine = typeof budgetLines.$inferSelect;
export type NewBudgetLine = typeof budgetLines.$inferInsert;
